// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"47aa5837","81":"dc4127c0","787":"7c3b58ff"}[chunkId] + ".chunk.js";
};